import * as React from "react";
const SvgMinusMediumBold = props => <svg xmlns="http://www.w3.org/2000/svg" width={20} height={20} fill="none" viewBox="0 0 20 20" {...props}><path fill="currentColor" d="M15.834 9.125a.875.875 0 0 1 0 1.75H4.167a.875.875 0 1 1 0-1.75z" /></svg>;
export default SvgMinusMediumBold;